<template>
  <div class="stock-context-bar">
    <v-row dense align="center">
      <v-col cols="12" md="5">
        <v-autocomplete
          v-model="localOrganizationIds"
          :items="organizationOptions"
          item-text="label"
          item-value="id"
          :label="$t('STOCK.CONTEXT.ORGANIZATIONS')"
          multiple
          chips
          small-chips
          clearable
          hide-details
          dense
          outlined
          @change="handleOrganizationsChange"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="5">
        <v-autocomplete
          v-model="localWarehouseIds"
          :items="warehouseOptions"
          item-text="label"
          item-value="id"
          :label="$t('STOCK.CONTEXT.WAREHOUSES')"
          multiple
          chips
          small-chips
          clearable
          hide-details
          dense
          outlined
          @change="persistContext"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-title>{{ item.label }}</v-list-item-title>
              <v-list-item-subtitle>
                {{ item.type }}<span v-if="item.virtual_subtype"> / {{ item.virtual_subtype }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="12" md="2" class="text-md-right">
        <v-btn icon color="primary" :loading="isLoading" @click="reloadOptions">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-btn icon color="grey darken-1" @click="clearContext">
          <v-icon>mdi-filter-remove</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { GET_ORGANIZATIONS_OPTIONS } from "@/store/organizations.module";
import { GET_STOCK_WAREHOUSE_OPTIONS } from "@/store/stock/stockWarehouses.module";
import { SET_STOCK_CONTEXT } from "@/store/stock/stockContext.module";

export default {
  name: "StockWarehouseContextBar",
  data() {
    return {
      isLoading: false,
      organizationOptions: [],
      warehouseOptions: [],
      localOrganizationIds: [],
      localWarehouseIds: [],
    };
  },
  computed: {
    warehouseOptionsRevision() {
      return this.$store.getters.stockWarehouseOptionsRevision;
    },
  },
  watch: {
    warehouseOptionsRevision() {
      this.reloadOptions();
    },
  },
  mounted() {
    this.localOrganizationIds = [...this.$store.getters.stockContextOrganizationIds];
    this.localWarehouseIds = [...this.$store.getters.stockContextWarehouseIds];
    this.reloadOptions();
  },
  methods: {
    reloadOptions() {
      this.isLoading = true;

      return Promise.all([
        this.$store.dispatch(GET_ORGANIZATIONS_OPTIONS, {}),
        this.$store.dispatch(GET_STOCK_WAREHOUSE_OPTIONS, {
          organization_ids: this.localOrganizationIds,
        }),
      ])
        .then(([organizations, warehouses]) => {
          this.organizationOptions = organizations.data || [];
          this.warehouseOptions = warehouses.data || [];
          const organizationsChanged = this.keepOnlyVisibleOrganizations();
          this.keepOnlyVisibleWarehouses();
          if (organizationsChanged) {
            this.persistContext();
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    handleOrganizationsChange() {
      this.reloadOptions().then(() => {
        this.persistContext();
      });
    },
    keepOnlyVisibleOrganizations() {
      const visibleOrganizationIds = this.organizationOptions.map((organization) => organization.id);
      const nextIds = this.localOrganizationIds.filter((id) => visibleOrganizationIds.includes(id));
      const changed = nextIds.length !== this.localOrganizationIds.length;

      this.localOrganizationIds = nextIds;

      return changed;
    },
    keepOnlyVisibleWarehouses() {
      const visibleWarehouseIds = this.warehouseOptions.map((warehouse) => warehouse.id);
      this.localWarehouseIds = this.localWarehouseIds.filter((id) => visibleWarehouseIds.includes(id));
    },
    clearContext() {
      this.localOrganizationIds = [];
      this.localWarehouseIds = [];
      this.reloadOptions().then(() => {
        this.persistContext();
      });
    },
    persistContext() {
      this.$store.dispatch(SET_STOCK_CONTEXT, {
        organization_ids: this.localOrganizationIds,
        warehouse_ids: this.localWarehouseIds,
      });
    },
  },
};
</script>
